import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles/createTheme';
import { EdwardColors } from 'enums';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root:(props: { warning?: boolean}) => ({
      '& .gauge': {
        width: '100%',
        height: '3px',
        margin: theme.spacing(1, 0),
        padding: 0,
        position: 'relative',
        '& .bgrDark': { backgroundColor: props.warning ? EdwardColors.WARNING : undefined },
        '& .dot': {
          width: '2px',
          height: '100%',
          background: theme.palette.grey[200],
          position: 'absolute',
          '&:last-child': { marginLeft: '-2px' },
        },
        '& .bar': {
          height: '100%',
          position: 'absolute',
        },
        '& .indicator, & .targetIndicator': {
          position: 'absolute',
          top: '-3px',
          width: '9px',
          height: '9px',
          borderRadius: '50%',
          marginLeft: '-3px',
        },
        '&.risk1 .bar': { width: '0%' },
        '&.risk2 .bar': { width: '11%' },
        '&.risk3 .bar': { width: '22%' },
        '&.risk4 .bar': { width: '33%' },
        '&.risk5 .bar': { width: '44%' },
        '&.risk6 .bar': { width: '55%' },
        '&.risk7 .bar': { width: '66%' },
        '&.risk8 .bar': { width: '77%' },
        '&.risk9 .bar': { width: '88%' },
        '&.risk10': {
          '& .bar': { width: '100%' },
          '& .indicator': { marginLeft: '-10px' },
        },
        '&.overview': {
          height: '4px',
          '& .indicator': {
            height: '12px',
            width: '12px',
            top: '-4px',
            marginLeft: '-6px',
          },
        },
        '&.total': {
          height: '6px',
          '& .indicator': {
            height: '18px',
            width: '18px',
            top: '-6px',
            marginLeft: '-9px',
          },
        },
      },
      '& .numbers': {
        display: 'flex',
        position: 'relative',
        height: '1rem',
        '& div': {
          width: '10%',
          textAlign: 'center',
          color: theme.palette.grey[600],
          position: 'absolute',
          transform: 'translate(-50%, 0)',
          '&.selected': {
            fontWeight: 'bold',
            color: 'black',
            '&.disabled': {
              color: '#757575',
            },
          },
          '&:first-child': { transform: 'translate(-40%, 0)' },
          '&:last-child': { transform: 'translate(-60%, 0)' },
        },
      },
      '& .n1': { left: 0 },
      '& .n2': { left: '11%' },
      '& .n3': { left: '22%' },
      '& .n4': { left: '33%' },
      '& .n5': { left: '44%' },
      '& .n6': { left: '55%' },
      '& .n7': { left: '66%' },
      '& .n8': { left: '77%' },
      '& .n9': { left: '88%' },
      '& .n10': { left: '100%' },
      '&.iqResult': {
        '& .sliderBgr': {
          backgroundColor: theme.palette.grey[400],
        },
        '& .bar': {
          backgroundColor: EdwardColors.DARK,
        },
        '& .indicator': {
          backgroundColor: EdwardColors.DARK,
        },
      },
      '&.riskAlt': {
        '& .sliderBgr': {
          backgroundColor: EdwardColors.GRAY_LIGHT,
        },
        '& .bar': {
          backgroundColor: EdwardColors.GRAY_MEDIUM,
          transition: 'width 0.3s cubic-bezier(0, 1, 0.5, 1)',
        },
        '& .gauge .indicator': {
          height: '28px',
          width: '28px',
          top: '-14px',
          marginLeft: '-12px',
          transition: 'left 0.3s cubic-bezier(0, 1, 0.5, 1)',
          zIndex: 1,
          '&.match': {
            backgroundColor: EdwardColors.GREEN,
          },
          '&.mismatch': {
            backgroundColor: EdwardColors.ALERT,
          },
          '&.n1': { marginLeft: '-10px' },
          '&.n10': { marginLeft: '-20px' },
        },
        '& .gauge .targetIndicator': {
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          top: '-20px',
          marginLeft: '-18px',
          background: 'transparent',
          transition: 'left 0.3s cubic-bezier(0, 1, 0.5, 1)',
          '&.n1': { marginLeft: '-16px' },
          '&.n10': { marginLeft: '-26px' },
          '&.match': {
            border: `solid 4px ${EdwardColors.GREEN}`,
            boxShadow: '0 0 8px rgba(82, 199, 0, 0.5), inset 0 0 4px rgba(82, 199, 0, 0.5)',
          },
          '&.mismatch': {
            border: `solid 4px ${EdwardColors.ALERT}`,
            boxShadow: '0 0 8px rgba(204, 0, 0, 0.5), inset 0 0 4px rgba(204, 0, 0, 0.5)',
          },
        },
        '& .numbers div': {
          fontSize: '22px',
          fontWeight: 'bold',
          width: '2%',
          lineHeight: 3.5,
          '&:first-child, &:last-child': { width: '10%' },
        },
        '& .numbers div.selected': {
          fontSize: '30px',
          lineHeight: '2.5',
          fontWeight: 'normal',
          transition: 'fontSize 0.3s cubic-bezier(0, 1, 0.5, 1)',
          '&.match': {
            color: EdwardColors.GREEN,
          },
          '&.mismatch': {
            color: EdwardColors.ALERT,
          },
        },
      },
    }),
  }),
);

export default useStyles;
